var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.860623 8.6365L4.74954 4.74759C4.98818 4.50894 5.3751 4.50894 5.61374 4.74759L9.50266 8.6365C9.7413 8.87515 9.7413 9.26206 9.50266 9.50071C9.26402 9.73935 8.8771 9.73935 8.63845 9.50071L5.18164 6.04389L1.72483 9.50071C1.48618 9.73935 1.09927 9.73935 0.860623 9.50071C0.62198 9.26206 0.62198 8.87514 0.860623 8.6365Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.860623 4.6365L4.74954 0.747587C4.98818 0.508944 5.3751 0.508944 5.61374 0.747587L9.50266 4.6365C9.7413 4.87515 9.7413 5.26206 9.50266 5.50071C9.26402 5.73935 8.8771 5.73935 8.63845 5.50071L5.18164 2.04389L1.72483 5.50071C1.48618 5.73935 1.09927 5.73935 0.860623 5.50071C0.62198 5.26206 0.62198 4.87514 0.860623 4.6365Z",
    fill: "white",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow2);
export default __webpack_public_path__ + "static/media/Arrow 2.e976cc9416f5b162f429ea64010c50ab.svg";
export { ForwardRef as ReactComponent };